import axios from "axios";
import { getOptions } from "../../helpers/api";

export const audit = {
  getAuditLookups: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Assignment/AuditLookups`, {...headers, cancelToken});
  },
  getAuditQualitySummaryData: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Assignment/AuditQualitySummaryData`, data.body, {...headers, cancelToken});
  },
  getUnAssignedIncidents: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Assignment/GetUnAssignedIncidentsPaginated?q=${data.SearchValue}&start=${data.Page}&limit=${data.Size}`, {...headers, cancelToken});
  },
  getUnAssignedIncidents: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Assignment/GetUnAssignedIncidentsPaginated?q=${data.SearchValue}&start=${data.Page}&limit=${data.Size}`, {...headers, cancelToken});
  },

  getAssignedIncidents: (data, cancelToken) => {
    const { headers } = getOptions(data);
    
    // Determine the status based on the selectedTab value
    const status = data.selectedTab === 'pending-audit'
      ? 'Pending'
      : data.selectedTab === 'archived'
        ? 'Approved'
        : 'Submitted';

    // Define the query parameters
    const params = {
      status: status,
      q: data.SearchValue,
      start: data.Page,
      limit: data.Size,
      municipality: data.municipality,
      month: data.month,
      filterAuditor: data.auditor,
      filterInspector: data.inspector,
      filterActivity: data.activity,
      filterFinalElement: data.finalElement,
      filterCheckListStatus: data.checkListStatus,
    };
  
    // Use the 'params' option to pass the payload
    return axios.get(`/mashhad.api/Assignment/AssignedIncidents`, {
      params,
      cancelToken,
      ...headers
    });
  },

  getAuditTaskDetails: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Assignment/AuditTaskDetails?IncidentId=${data.IncidentId}`, {...headers, cancelToken});
  },

  approveOrRejectAuditTask: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Assignment/SubmitAudit`, data.body, {...headers, cancelToken});
  },
};
